import * as ActionTypes from '../../constants/ActionTypes';

// Get appointment settings
export const getAppointmentSettings = () => ({
    type: ActionTypes.GET_APPOINTMENT_SETTINGS_REQUEST,
    payload: {}
});

export const getAppointmentSettingsSuccess = (settings) => ({
    type: ActionTypes.GET_APPOINTMENT_SETTINGS_SUCCESS,
    payload: settings
});

export const getAppointmentSettingsFailure = (error) => ({
    type: ActionTypes.GET_APPOINTMENT_SETTINGS_FAILURE,
    payload: error
});

// Update appointment settings
export const updateAppointmentSettings = (settings) => ({
    type: ActionTypes.UPDATE_APPOINTMENT_SETTINGS_REQUEST,
    payload: { settings }
});

export const updateAppointmentSettingsSuccess = (settings) => ({
    type: ActionTypes.UPDATE_APPOINTMENT_SETTINGS_SUCCESS,
    payload: settings
});

export const updateAppointmentSettingsFailure = (error) => ({
    type: ActionTypes.UPDATE_APPOINTMENT_SETTINGS_FAILURE,
    payload: error
});

// Add blocked date
export const addBlockedDate = (date, reason) => ({
    type: ActionTypes.ADD_BLOCKED_DATE_REQUEST,
    payload: { date, reason }
});

export const addBlockedDateSuccess = (blockedDates) => ({
    type: ActionTypes.ADD_BLOCKED_DATE_SUCCESS,
    payload: blockedDates
});

export const addBlockedDateFailure = (error) => ({
    type: ActionTypes.ADD_BLOCKED_DATE_FAILURE,
    payload: error
});

// Remove blocked date
export const removeBlockedDate = (date) => ({
    type: ActionTypes.REMOVE_BLOCKED_DATE_REQUEST,
    payload: { date }
});

export const removeBlockedDateSuccess = (blockedDates) => ({
    type: ActionTypes.REMOVE_BLOCKED_DATE_SUCCESS,
    payload: blockedDates
});

export const removeBlockedDateFailure = (error) => ({
    type: ActionTypes.REMOVE_BLOCKED_DATE_FAILURE,
    payload: error
});

// Get available dates
export const getAvailableDates = () => ({
    type: ActionTypes.GET_AVAILABLE_DATES_REQUEST,
    payload: {}
});

export const getAvailableDatesSuccess = (dates) => ({
    type: ActionTypes.GET_AVAILABLE_DATES_SUCCESS,
    payload: dates
});

export const getAvailableDatesFailure = (error) => ({
    type: ActionTypes.GET_AVAILABLE_DATES_FAILURE,
    payload: error
});

// Clear appointment settings errors
export const clearAppointmentSettingsErrors = () => ({
    type: ActionTypes.CLEAR_APPOINTMENT_SETTINGS_ERRORS
});

// Reset appointment settings state
export const resetAppointmentSettingsState = () => ({
    type: ActionTypes.RESET_APPOINTMENT_SETTINGS_STATE
});

// Set appointment settings loading
export const setAppointmentSettingsLoading = (loading) => ({
    type: ActionTypes.SET_APPOINTMENT_SETTINGS_LOADING,
    payload: loading
});
